module.exports = __webpack_public_path__ + "img/activity13.f6781412.png";